module.exports = __webpack_public_path__ + "static/media/office10.660b112a.jpg";